/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FlowChartResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { Measurement } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { PageLikeMeasurement } from '../n3-backend-open-api-gen/model';
/**
 * MeasurementV2ControllerApi - axios parameter creator
 */
export const MeasurementV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} deviceId 
         * @param {FlowChartViewModeEnum} viewMode 
         * @param {string} viewTime 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowChart: async (deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('flowChart', 'deviceId', deviceId)
            // verify required parameter 'viewMode' is not null or undefined
            assertParamExists('flowChart', 'viewMode', viewMode)
            // verify required parameter 'viewTime' is not null or undefined
            assertParamExists('flowChart', 'viewTime', viewTime)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('flowChart', 'timezone', timezone)
            const localVarPath = `/api/v2/measurement/measurements/flow-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (viewMode !== undefined) {
                localVarQueryParameter['viewMode'] = viewMode;
            }

            if (viewTime !== undefined) {
                localVarQueryParameter['viewTime'] = (viewTime as any instanceof Date) ?
                    (viewTime as any).toISOString() :
                    viewTime;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intervalFlowData: async (deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('intervalFlowData', 'deviceId', deviceId)
            const localVarPath = `/api/v2/measurement/measurements/interval-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlow: async (deviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('totalFlow', 'deviceId', deviceId)
            const localVarPath = `/api/v2/measurement/total-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlowData: async (deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('totalFlowData', 'deviceId', deviceId)
            const localVarPath = `/api/v2/measurement/measurements/total-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementV2ControllerApi - functional programming interface
 */
export const MeasurementV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} deviceId 
         * @param {FlowChartViewModeEnum} viewMode 
         * @param {string} viewTime 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowChart(deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowChartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowChart(deviceId, viewMode, viewTime, timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementV2ControllerApi.flowChart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async intervalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLikeMeasurement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.intervalFlowData(deviceId, from, to, pageSize, currentPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementV2ControllerApi.intervalFlowData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalFlow(deviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Measurement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totalFlow(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementV2ControllerApi.totalFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLikeMeasurement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totalFlowData(deviceId, from, to, pageSize, currentPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementV2ControllerApi.totalFlowData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementV2ControllerApi - factory interface
 */
export const MeasurementV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} deviceId 
         * @param {FlowChartViewModeEnum} viewMode 
         * @param {string} viewTime 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowChart(deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options?: RawAxiosRequestConfig): AxiosPromise<FlowChartResponse> {
            return localVarFp.flowChart(deviceId, viewMode, viewTime, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intervalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageLikeMeasurement> {
            return localVarFp.intervalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlow(deviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Measurement> {
            return localVarFp.totalFlow(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageLikeMeasurement> {
            return localVarFp.totalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementV2ControllerApi - object-oriented interface
 */
export class MeasurementV2ControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} deviceId 
     * @param {FlowChartViewModeEnum} viewMode 
     * @param {string} viewTime 
     * @param {string} timezone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public flowChart(deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options?: RawAxiosRequestConfig) {
        return MeasurementV2ControllerApiFp(this.configuration).flowChart(deviceId, viewMode, viewTime, timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} deviceId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [pageSize] 
     * @param {number} [currentPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public intervalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig) {
        return MeasurementV2ControllerApiFp(this.configuration).intervalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public totalFlow(deviceId: number, options?: RawAxiosRequestConfig) {
        return MeasurementV2ControllerApiFp(this.configuration).totalFlow(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} deviceId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [pageSize] 
     * @param {number} [currentPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public totalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig) {
        return MeasurementV2ControllerApiFp(this.configuration).totalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FlowChartViewModeEnum = {
    Hourly: 'hourly',
    Daily: 'daily',
    Weekly: 'weekly',
} as const;
export type FlowChartViewModeEnum = typeof FlowChartViewModeEnum[keyof typeof FlowChartViewModeEnum];
